export default __webpack_public_path__ + "static/media/ASTERION PARTNERS copie 2.7f169648.png";